// Browser-local half-open day window for dashboard summary transport.

export function buildLocalDayWindow(now = new Date()) {
  const dayStart = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,
    0,
    0,
    0,
  );
  const dayEnd = new Date(dayStart);
  dayEnd.setDate(dayEnd.getDate() + 1);
  return {
    day_start: dayStart.toISOString(),
    day_end: dayEnd.toISOString(),
    dayStart,
    dayEnd,
  };
}

export function buildSummaryQueryParams(dayWindow) {
  return {
    day_start: dayWindow.day_start,
    day_end: dayWindow.day_end,
  };
}
